import StartSsoAuthentication from '@Application/Security/Sso/Commands/StartSsoAuthentication';
import startSsoAuthentication from '@Application/Security/Sso/startSsoAuthentication';
import type { InvitationPayload } from '@Application/Security/Invitations/Actions/invitationFetched';
import ignoreHandledError from '@UI/Helpers/ignoreHandledError';
import InvitationSummary from '@UI/Pages/Authentication/Invitation/Shared/InvitationSummary';
import * as React from 'react';
import { useDispatch } from '@verclam/synapse';
import { Button } from '@verclam/ui-kit';

type Props = {
	readonly invitation: InvitationPayload;
};

/**
 * `signInMethod: 'identity_provider'` (§8.5): the account has no password to define, only a
 * fournisseur to start a session with. The e-mail is always the invitation's own — never a field on
 * this screen — and `redirectPath` is omitted: a freshly entered invitee has no interrupted
 * destination to resume, they go to the dashboard.
 */
const InvitationBySso: React.FC<Props> = ({ invitation }) => {
	const dispatch = useDispatch();
	const [isStartingSso, setIsStartingSso] = React.useState(false);

	const handleStartSso = React.useCallback(() => {
		setIsStartingSso(true);

		dispatch(startSsoAuthentication(new StartSsoAuthentication(invitation.email, null)))
			.catch(ignoreHandledError) // toast displayed by AuthenticationNotifications
			.finally(() => setIsStartingSso(false));
	}, [dispatch, invitation.email]);

	return (
		<React.Fragment>
			<InvitationSummary
				organizationNames={invitation.organizationNames}
				roleLabel={invitation.roleLabel}
				facilityNames={invitation.facilityNames}
			/>
			<Button
				type="button"
				label="Se connecter avec le compte de ma structure"
				onClick={handleStartSso}
				loading={isStartingSso}
			/>
		</React.Fragment>
	);
};

export default InvitationBySso;
